// Hook to access current theme colors
import { useApp } from '../context/AppContext';

export const useThemeColors = () => {
  const { currentTheme } = useApp();
  return currentTheme.colors;
};

